module.exports = __webpack_public_path__ + "img/tianJa.704cce7c.png";